import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create(() => ({
  content: {
    paddingHorizontal: theme.spacing[7],
    paddingBottom: theme.spacing[8],
    gap: theme.spacing[7],
  },
  closeRow: {
    justifyContent: 'flex-end',
  },
  header: {
    gap: theme.spacing[3],
    alignItems: 'center',
  },
  title: {
    textAlign: 'center',
  },
  description: {
    textAlign: 'center',
  },
  actions: {
    gap: theme.spacing[3],
  },
}));
